import React, { useState } from "react";
import { setUserAccess } from "../services/User";

export default function AccessTimeControl({ selectedUsers, onDone }) {
  const [choice, setChoice] = useState("24");
  const [custom, setCustom] = useState("");

  const apply = async () => {
    if (!selectedUsers || selectedUsers.length === 0) {
      return alert("Select at least one user first");
    }
    let hours;
    if (choice === "unlimited") hours = null;
    else if (choice === "custom") hours = Number(custom);
    else hours = Number(choice);

    if (choice !== "unlimited" && (!hours || hours <= 0)) {
      return alert("Enter a valid number of hours");
    }

    await setUserAccess({ selectedUsers, hours });
    alert("Access time updated");
    if (onDone) onDone();
  };

  return (
    <div style={{ display: "flex", gap: 8, alignItems: "center" }}>
      <label>Access time:</label>
      <select value={choice} onChange={(e) => setChoice(e.target.value)}>
        <option value="24">24 hours</option>
        <option value="48">48 hours</option>
        <option value="72">72 hours</option>
        <option value="custom">Custom (hours)</option>
        <option value="unlimited">Unlimited</option>
      </select>
      {choice === "custom" && (
        <input
          type="number"
          min="1"
          value={custom}
          onChange={(e) => setCustom(e.target.value)}
          placeholder="Hours"
          style={{ width: 80 }}
        />
      )}
      <button onClick={apply}>Apply</button>
    </div>
  );
}
